module.exports = {
      id: "business-usage",
      viewBox: "0 0 28.79 24.369",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#business",
      toString: function () {
        return this.url;
      }
    }